import ErrorPage from '../ErrorPage';

const NotFound = () => (
  <ErrorPage
    code="404"
    title="Page non trouvée"
    description={"La page que vous recherchez n'existe pas ou n'est plus disponible."}
  />
);

export default NotFound;
